<script setup>
import { useGlobalStore } from "@stores/global";
import IconCheckmark from "@components/icons/Checkmark.vue";
import Button from "@components/Button.vue";

const globalStore = useGlobalStore();

function handleOk() {
    globalStore.closeModal();
    globalStore.setPage("explore");
}
</script>

<template>
    <div class="flex w-full max-w-[600px]">
        <div
            class="flex flex-1 flex-col items-center gap-8 overflow-y-auto p-6 lg:gap-10 lg:p-10"
        >
            <div class="bg-marine-600 flex size-12 items-center justify-center">
                <IconCheckmark class="size-6 text-yellow-400" />
            </div>

            <div class="flex flex-col gap-4 text-center">
                <p
                    class="h5 leading-[0.9] font-bold tracking-tight text-balance uppercase"
                >
                    Your submission has been sent successfully.
                </p>
                <!-- <p class="body-sm leading-[1.4] faded-text">
                    Lorem ipsum dolor sit amet, consectetur adipiscing
                </p> -->
            </div>

            <Button className="w-full lg:w-auto" @click="handleOk"
                >Let's Explore</Button
            >
        </div>
    </div>
</template>
